import { z } from "zod";

export interface Hobbie {
  id: number;
  nombre: string;
}

export interface Profession {
  id: number;
  nombre: string;
}

export const relationFieldSchema = z.object({
  nombre: z.any().optional(),
});
